



// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import { mapActions, mapGetters } from "vuex";

// Constants
import RouteNames from "@/constants/route-names.ts";

// Enums
import { LineColor } from "@/clickbuy/purchase/views/shopping-cart/shopping-cart-line/index.vue";

// Views
import FormView from "@/shared/views/form.view.vue";
import SaleInfoView from "@/clickbuy/purchase/views/sale-info.view.vue";
import ProductCard from "@/clickbuy/purchase/views/product-card.view.vue";
import ProductBranch from "@/clickbuy/purchase/views/product-branch.view.vue";
import ShoppingCartLine from "@/clickbuy/purchase/views/shopping-cart/shopping-cart-line/index.vue";
import ChoosePaymentMethod from '@/client/budget/views/acceptance/choose-payment-method/index.vue';

// Components
import SelectTag from "@/shared/components/select.tag.component.vue";
import Icon from "@/shared/components/icon.component.vue";
import Input, {
  InputType,
  InputSize,
  InputAlign,
  InputTextWeigth
} from "@/shared/components/input.component.vue";
import Field from "@/shared/components/field.component.vue";
import ItemThumb from "@/shared/components/item-thumb.component.vue";
import GroupButton from "@/shared/components/group-button.component.vue";
import Dropdown, {
  DropdownWidth,
  DropdownStyle
} from "@/shared/components/Dropdown.component.vue";
import Btn, {
  BtnPredefinedStyle,
  BtnWidth,
  BtnHeight,
  BtnColor
} from '@/shared/components/btn.component.vue';
import Checkbox, { CheckboxPredefinedStyle } from '@/shared/components/checkbox.component.vue';
import SearchAutocomplete from "@/shared/components/SearchAutocomplete.component.vue";
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextSize,
} from "@/shared/components/FlatSelectorText.component.vue";
import SpotlightText, {
  SpotlightTextColor,
} from "@/shared/components/SpotlightText.component.vue";

// Models
import {
  TypeOfProduct,
  Branch,
  TypeOfPriceLiteral
} from "@/manager/product/models/product.model.ts";
import {
  PaymentMethod,
  PaymentMethodLiteral
} from "@/clickbuy/purchase/models/purchase.model.ts";
import { PurchaseLine } from "@/clickbuy/purchase/models/purchase-line.model.ts";
import {
  BudgetPaymentMethod,
  BudgetPaymentStatus,
} from '@/manager/budget/models/budget.model';
import {
  Budget,
} from '@/manager/budget/models/budget.model';

// Services
import Assets from "@/constants/assets.ts";
import UtilsService from "@/core/services/utils.service";

// Filters
import round from "@/shared/filters/round.filter.ts";

//Mixins
import ErrorMixin from "@/shared/mixins/error.mixin";
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';



interface MixinInterface extends ErrorMixin, NotificationMessage { }

@Component({
  components: {
    FormView,
    Field,
    Icon,
    SelectTag,
    Input,
    SaleInfoView,
    ProductCard,
    ProductBranch,
    ItemThumb,
    ShoppingCartLine,
    GroupButton,
    Dropdown,
    Btn,
    Checkbox,
    SpotlightText,
    SearchAutocomplete,
    FlatSelectorText,
    ChoosePaymentMethod
  },
  computed: {
    ...mapGetters({
      clientList: "getClientList",
      currentPurchase: "getCurrentPurchase",
      purchaseTagList: "getPurchaseTagList",
      hasPurchaseLines: "currentPurchaseHasPurchaseLines",
      purchaseFinished: "currentPurchaseFinished",
      sellingCourses: "currentPurchaseTypeOfProductIsCourse",
      sellingBooks: "currentPurchaseTypeOfProductIsBook",
      sellingMerchandising: "currentPurchaseTypeOfProductIsMerchandising",
      previousPurchaseIsCanceled: "previousPurchaseIsCanceled",
      acquiredCourses: 'acquiredCoursesList',
      convocationBalance: "getConvocationBalance",
      calculatedReserveAmount: "getCurrentPurchaseReserveAmount",
      getProfile: "getProfile",
      userMoneyFlow: "getUserMoneyFlow",
      hasUserMoneyFlow: "hasUserMoneyFlow",
      currentBudget: 'getCurrentBudgetAcceptance',
      isCardMethodSelected: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      isDirectDebitMethodSelected:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',
      getTypeOfPrice: 'getTypeOfPrice',
    })
  },
  methods: {
    ...mapActions({
      setCurrentBudget: 'setCurrentBudgetAcceptance',
    })
  },
  filters: {
    round
  }
})
export default class ShoppingCart extends Mixins<MixinInterface>(ErrorMixin, NotificationMessage) {
  @Prop({ default: false }) private modeModal!: boolean;

  private assets = Assets;
  private paymentMethodLiteral = PaymentMethodLiteral;
  private dropdownWidth = DropdownWidth;
  private DropdownStyle = DropdownStyle;
  private checkboxPredefinedStyle = CheckboxPredefinedStyle;
  private internalBusinessList: Array<any> = [];
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private getProfile!: any;
  private currentPurchase!: any;
  private calculatedReserveAmount!: any;
  private purchaseFinished!: any;
  private convocationBalance!: number;
  private hasPurchaseLines!: any;
  private sellingCourses!: boolean;
  private sellingBooks!: boolean;
  private saldo!: boolean;
  private previousPurchaseIsCanceled!: boolean;
  private sellingMerchandising!: boolean;
  private userMoneyFlow!: number;
  private hasUserMoneyFlow!: boolean;
  private inputType = InputType;
  private inputSize = InputSize;
  private inputAlign = InputAlign;
  private inputTextWeigth = InputTextWeigth;
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private flatSelectorTextSize = FlatSelectorTextSize;
  private productTypeSelected = this.fiscalDataExtensionsList[0];
  private acquiredCourses!: any;
  // private productTypeSelected:any
  // private productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
  private isDefaultFiscalData = true;
  private fiscalDataExtensionList: any;
  private fiscalData =
    {
      'user': '',
      'userId': '',
      'email': '',
      'address': '',
      'postalCode': '',
      'country': '',
      'town': '',
      'state': '',
      'firstName': '',
      'lastName': '',
      'secondLastName': '',
      'nif': '',
      'phone': ' ',
      'id': '',
      'isDefault': false
    };
  private selectNewFiscalData: any;

  public error: any = {
    fiscalData: {
      postalCode: "",
      nif: "",
      firstName: "",
      lastName: "",
      email: "",
    },
    nonFieldErrors: "",
  };
  private isNewFiscalDataExtension = false;
  private updateFiscalDataExtension = false;
  private searchStringFiscalData = ""
  private selectedOptionFiscalData!: any;
  private selectedClientFiscalData!: any
  private rescatarFiscalDataBool = false
  private searchTimeout: any = null
  private searchFiscalDataExtensionsList: any = [];
  private clientCountryList: any = [];
  private clientProvinceList: any = [];
  private clientPostalCodeList: any = [];
  private showAddPaymentInfoBoolean: any = false
  private currentBudget?: any;
  private isCardMethodSelected!: any;
  private isDirectDebitMethodSelected!: any;
  private getTypeOfPrice!: any;
  private newPaymentAdded: any = false
  private clientPayments: any
  private clientPaymentSelected: any = this.clientPayments ? this.clientPayments[0] : '';
  private setCurrentBudget!: any;
  private zipcodes: any;
  private updateKey: any;

  get fiscalDataExtensionsList(): any[] {
    return [
      { nif: 'seleccione' },
      { nif: 'Avenida Gabriel Roca, 8, piso 3' },
      { nif: 'Calle Rafel Rodriguez Mendez, 1, piso 2A' },
    ];
  }

  get purchaselinesHasPack() {
    if (this.hasPurchaseLines) {
      if (Boolean(this.currentPurchase.purchaseLines.filter((item: any) => item.product.pack != null).length)) {
        this.currentPurchase.soonPaymentPurchaseCheck = false;
        this.setSoonPayment()
        return true;
      }
    }
    return false
  }

  get provinceSelected() {
    const provinceId: any = this.fiscalData.state;
    let result = {
      value: "",
      label: ""
    };

    if (provinceId != 'SIN DATOS' && typeof provinceId === "string") {
      result = this.clientProvinceList.find((option: any) => {
        return option.value === provinceId;
      });
    } else if (typeof provinceId === 'object' && provinceId !== null && provinceId.value) {
      result = this.clientProvinceList.find((option: any) => {
        return option.value === provinceId.value;
      });
    }

    this.fetchPostalCodeList(provinceId);
    return result;
  }

  get countrySelected() {
    const countryId: any = this.fiscalData.country;
    let result = {
      value: "",
      label: ""
    };

    if (countryId != 'SIN DATOS' && typeof countryId === "string") {
      result = this.clientCountryList.find((option: any) => {
        return option.value === countryId;
      });
    } else if (typeof countryId === 'object' && countryId !== null && countryId.value) {
      result = this.clientCountryList.find((option: any) => {
        return option.value === countryId.value;
      });
    }

    // this.fetchPostalCodeList(countryId);
    return result;
  }

  @Watch("currentPurchase.reserveAmount")
  public watchsearchPreviousReserveAmount(newVal: any, oldVal: any) {
    // if (this.currentPurchase.soonPaymentPurchaseCheck && this.currentPurchase.modifyPurchase && (this.currentPurchase.totalPrice) < 0 && this.currentPurchase.purchaseLines.length > 0) {
    //   this.currentPurchase.notBillable = true;
    // }
  }

  // @Watch("currentPurchase.totalPrice")
  // public watchTotalPrice(newVal: any, oldVal: any) {
  //   const saldo = this.purchaseTagList.filter((item: any) => item.name == "SALDO")[0]
  //   if (this.currentPurchase.soonPaymentPurchaseCheck && newVal < 0 && this.currentPurchase.purchaseLines.length > 0) {
  //     if (!this.currentPurchase.tags.some((item:any)=>JSON.stringify(item) == JSON.stringify(saldo))) {
  //       this.currentPurchase.tags.push(saldo);
  //     }
  //   } else if(newVal>=0){
  //     if (!this.currentPurchase.tags.some((item:any)=>JSON.stringify(item) == JSON.stringify(saldo))) {
  //       this.currentPurchase.tags.pop(saldo);
  //     }
  //   }

  // }
  @Watch("currentPurchase.totalPrice")
  public watchTotalPrice(newVal: any, oldVal: any) {
    if (this.currentPurchase.soonPaymentPurchaseCheck && this.currentPurchase.modifyPurchase && (this.currentPurchase.totalPrice) < 0 && this.currentPurchase.purchaseLines.length > 0) {
      this.currentPurchase.notBillable = true;
    }

    if (this.currentPurchase.soonPaymentPurchaseCheck && newVal < 0 && this.currentPurchase.purchaseLines.length > 0) {
      this.saldo = true;
    } else {
      this.saldo = false;
    }
  }

  @Watch("searchStringFiscalData")
  public watchsearchStringFiscalData(newVal: any, oldVal: any) {

    if (this.searchTimeout != null) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.searchCallback();
    }, 1000);

  }

  @Watch("acquiredCourses")
  private setProductTypeSelected(newVal: any, oldVal: any) {
    this.fetchClientPayment(0);
    this.rescatarFiscalDataBool = false;
    if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions) {
      this.fiscalDataExtensionList = this.acquiredCourses.fiscalDataExtensions
    }
    if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length > 0 && this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0]) {
      this.checkCurrentFiscalDataExtension()
      if (this.selectNewFiscalData) {
        this.productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.selectNewFiscalData)[0];
        this.selectNewFiscalData = undefined
      } else {
        this.productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0];
      }
      this.currentPurchase.fiscalData = this.fiscalData;
      this.currentPurchase.fiscalDataExtensionId = this.fiscalData.id;
      // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
      this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
    } else if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length == 0) {
      // set fiscal data if there is not fiscal data extension
      // this.isNewFiscalDataExtension = true
      this.checkCurrentFiscalDataExtension()
    } else {
      this.productTypeSelected = this.fiscalDataExtensionsList[0];
    }
  }

  @Watch("productTypeSelected")
  private watchProductTypeSelected(newVal: any, oldVal: any) {
    this.isNewFiscalDataExtension = false;
    this.isDefaultFiscalData = false;
    this.fiscalData = {
      'user': newVal.userId,
      'userId': '',
      'email': newVal.email || 'SIN@DATOS.COM',
      'address': newVal.address || 'SIN DATOS',
      'postalCode': newVal.postalCode,
      'country': newVal.country || 'SIN DATOS',
      'state': newVal.state || 'SIN DATOS',
      'town': newVal.town || 'SIN DATOS',
      'firstName': newVal.firstName || 'SIN DATOS',
      'lastName': newVal.lastName || 'SIN DATOS',
      'secondLastName': newVal.secondLastName || 'SIN DATOS',
      'nif': newVal.nif,
      'phone': newVal.phone || '34',
      'id': newVal.id,
      'isDefault': false
    }
    this.currentPurchase.fiscalData = this.fiscalData;
    this.currentPurchase.fiscalDataExtensionId = this.fiscalData.id;
    // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
  }


  @Watch("currentPurchase")
  private watchCurrentPurchase(newVal: any, oldVal: any) {
    if (!newVal.client.user.id) {
      this.clientPayments = undefined
      this.clientPaymentSelected = undefined
    }
    if (!newVal.fiscalDataExtensionId) {
      this.fiscalData = {
        'user': '',
        'userId': '',
        'email': '',
        'address': '',
        'postalCode': '',
        'country': '',
        'town': '',
        'state': '',
        'firstName': '',
        'lastName': '',
        'secondLastName': '',
        'nif': '',
        'phone': ' ',
        'id': '',
        'isDefault': false
      };
    }
  }

  private setProvince() {
    setTimeout(() => {
      let result = this.clientPostalCodeList.find((option: any) => {
        return option.value.slice(0, 2) === this.fiscalData.postalCode.slice(0, 2);
      });

      if (this.fiscalData.postalCode.length == 5) {
        let zipCodesResults = this.zipcodes.filter((zipcode: any) => zipcode.zipcode === this.fiscalData.postalCode);
        if (zipCodesResults.length > 0) {
          this.fiscalData.town = zipCodesResults[0].place
        }
      }

      if (result) {
        this.fiscalData.country = result.country;
        this.fiscalData.state = result.province;
      }
    }, 1000);
  }

  private fetchProvinceList() {
    this.$store.dispatch("fetchClientProvinceList").then((res) => {
      this.clientProvinceList = res.map((e: any) => {
        const option = {
          value: e.name,
          label: e.name,
        };
        return option;
      });
      this.updateKey++;
    });
  }

  private fetchCountryList() {
    this.$store.dispatch("fetchClientCountryList").then((res) => {
      this.clientCountryList = res.map((e: any) => {
        const option = {
          value: e.name,
          label: e.name,
        };
        return option;
      });
      this.updateKey++;
    });
  }

  private fetchPostalCodeList(province: any) {
    this.$store.dispatch("fetchClientPostalCodeList", /* province */).then((res) => {
      this.clientPostalCodeList = res.map((e: any) => {
        const option = {
          value: e.name || '',
          label: e.name || '',
          province: e.province ? e.province.name : '',
          country: e.province && e.province.country ? e.province.country.name : ''
        };
        return option;
      });
    });
  }

  private updateCP(province: any) {
    this.fetchPostalCodeList(province.value);
  }

  get postalCodeSelected() {
    const postalCodeId = this.currentPurchase.client.user.profile.postalCode;
    let result = {};
    if (postalCodeId) {
      result = this.clientPostalCodeList.find((option: any) => {
        return option.value === postalCodeId;
      });
    }
    return result;
  }

  private watchCardLastDigits(newVal: any, oldVal: any) {
    this.currentPurchase.cardLastDigits = newVal

    const paymentMethodsParent = document.getElementById('paymentMethods');
    if (paymentMethodsParent) {
      // Verificar si el elemento padre existe
      const elementosConClase: any = paymentMethodsParent.getElementsByClassName('button--active')[0];

      if (elementosConClase) {
        elementosConClase.click()
      }
    }

    this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
  }


  @Watch('fiscalData.phone')
  private watchPhone(newVal: any, oldVal: any) {
    if (!newVal) {
      this.fiscalData.phone = '+';
    } else if (newVal.charAt(0) != '+') {
      newVal = '+' + newVal;
      this.fiscalData.phone = newVal;
    } else {
      this.fiscalData.phone = newVal;
    }
  }

  private updateCurrentFiscalDataExtension() {
    this.updateFiscalDataExtension = true;
    this.setCurrentFiscalDataExtension()
    this.currentPurchase.fiscalDataExtensionId = '';
    this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
  }

  private checkCurrentFiscalDataExtension() {
    if (this.fiscalData.id == '' || this.fiscalData.user == '') {
      this.setCurrentFiscalDataExtension()
    }
  }

  private setCurrentFiscalDataExtension() {
    let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
    if (this.isDefaultFiscalData) {
      if (defaultExtension.length > 0) {
        this.fiscalData = {
          'user': this.acquiredCourses.userId,
          'userId': '',
          'email': this.acquiredCourses.fiscalData.email || 'SIN@DATOS.COM',
          'address': this.acquiredCourses.fiscalData.address || 'SIN DATOS',
          'postalCode': this.acquiredCourses.fiscalData.postalCode,
          'country': this.acquiredCourses.fiscalData.country || 'SIN DATOS',
          'town': this.acquiredCourses.fiscalData.town || 'SIN DATOS',
          'state': this.acquiredCourses.fiscalData.state || 'SIN DATOS',
          'firstName': this.acquiredCourses.fiscalData.firstName || 'SIN DATOS',
          'lastName': this.acquiredCourses.fiscalData.lastName || 'SIN DATOS',
          'secondLastName': this.acquiredCourses.fiscalData.secondLastName || 'SIN DATOS',
          'nif': this.acquiredCourses.fiscalData.nif,
          'phone': this.acquiredCourses.fiscalData.phone || '34',
          'id': defaultExtension[0].id,
          'isDefault': true
        }
      } else {
        this.fiscalData = {
          'user': this.acquiredCourses.userId,
          'userId': '',
          'email': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.email : 'SIN@DATOS.COM',
          'address': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.address : 'SIN DATOS',
          'postalCode': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.postalCode : '',
          'country': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.country : 'SIN DATOS',
          'town': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.town : 'SIN DATOS',
          'state': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.state : 'SIN DATOS',
          'firstName': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.firstName : 'SIN DATOS',
          'lastName': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.lastName : 'SIN DATOS',
          'secondLastName': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.secondLastName : 'SIN DATOS',
          'nif': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.nif : '',
          'phone': this.acquiredCourses.fiscalData ? this.acquiredCourses.fiscalData.phone : '34',
          'id': '',
          "isDefault": true
        }
      }
    }
  }

  private patchFiscalDataExtension(data: any, userId: any, id: any) {
    if (this.checkMandatoryFields()) {
      this.updateFiscalDataExtension = false;
      if (data.phone) {
        data.phone = data.phone.replaceAll(/\s/g, '');
      }
      // data = {'isDefault': data};
      const payload = {
        id,
        userId,
        data,
      };
      this.$store.dispatch('patchFiscalDataExtension', payload);
      setTimeout(() => {
        // this.fetchFiscalDataExtensionsList();
      }, 1000);
    }
    // 2000
  }

  private patchFiscalDataDefaultExtension(data: any, userId: any, id: any) {
    if (this.checkMandatoryFields()) {
      this.updateFiscalDataExtension = false;
      // data = {'isDefault': data};
      data.isDefault = true;
      if (data.phone) {
        data.phone = data.phone.replaceAll(/\s/g, '');
      }
      const payload = {
        id,
        userId,
        data,
      };
      this.$store.dispatch('patchFiscalDataExtension', payload).then(
        res => {
          this.$store.dispatch("fetchAcquiredCoursesList", { id: userId })
          this.showMessage("Cambios realizados correctamente")
          this.$emit('savedFiscalDataEmit', true);
        }
      );
      setTimeout(() => {
        // this.fetchFiscalDataExtensionsList();
      }, 1000);
    }
    // 2000
  }

  private showMessage(message: any) {
    let color = this.ownSpotlightTextColor.Primary;
    let text = message;
    if (message.error) {
      color = this.ownSpotlightTextColor.Error;
    }
    if (message.message) {
      text = message.message;
    }
    this.showNotification(text, color);
  }

  private newFiscalDataExtension() {
    this.isDefaultFiscalData = false;
    this.isNewFiscalDataExtension = true;
    this.fiscalData = {
      'user': this.acquiredCourses.userId,
      'userId': '',
      'email': 'SIN@DATOS.COM',
      'address': 'SIN DATOS',
      'postalCode': '',
      'country': 'SIN DATOS',
      'town': 'SIN DATOS',
      'state': 'SIN DATOS',
      'firstName': 'SIN DATOS',
      'lastName': 'SIN DATOS',
      'secondLastName': 'SIN DATOS',
      'nif': '',
      'phone': '34',
      'id': '',
      'isDefault': false
    }
    this.currentPurchase.fiscalData = this.fiscalData;
    this.currentPurchase.fiscalDataExtensionId = this.fiscalData.id;
    this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
  }

  private addFiscalDataExtension(fiscalData: any, status?: any) {
    if (this.checkMandatoryFields()) {
      if (status) {
        fiscalData.isDefault = status
      } else if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length == 0) {
        // If is new fiscal data and it's the first one
        fiscalData.isDefault = true
      } else {
        fiscalData.isDefault = false
      }
      if (fiscalData.phone) {
        fiscalData.phone = fiscalData.phone.replaceAll(/\s/g, '');
      }
      this.isNewFiscalDataExtension = false;
      this.updateFiscalDataExtension = false;
      this.rescatarFiscalDataBool = false;
      this.$store.dispatch('newFiscalDataExtension', fiscalData).then(
        res => {
          this.selectNewFiscalData = res.id
          this.fiscalData = res
          this.currentPurchase.fiscalData = res;
          this.currentPurchase.fiscalDataExtensionId = res.id;
          this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
          this.$store.dispatch("fetchAcquiredCoursesList", { id: fiscalData.user })
          // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
          this.showMessage("Datos fiscales guardados correctamente")
          this.$emit('savedFiscalDataEmit', true);
        }
      );
    }
  }

  get paymentOptions() {
    const options = [
      {
        id: PaymentMethod.Cash.toString(),
        text: "Efectivo"
      },
      {
        id: PaymentMethod.Card.toString(),
        text: "Tarjeta"
      },
      {
        id: PaymentMethod.SendWireTransfer.toString(),
        text: "Transferencia"
      },
      {
        id: PaymentMethod.Bizum.toString(),
        text: "Bizum"
      },
      {
        id: PaymentMethod.Web.toString(),
        text: "Web"
      },
      {
        id: PaymentMethod.DirectDebit.toString(),
        text: "Domiciliación"
      },
    ];

    // if (this.getProfile && this.getProfile.isAdmin) {
    //   options.push({
    //     id: PaymentMethod.SendWireTransfer.toString(),
    //     text: "Transferencia"
    //   });
    // }

    return options;
  }

  get toPayColumnClass() {
    let cssClass = "reseve-amount";
    if (this.previousPurchaseIsCanceled) {
      cssClass = "total-price";
    }
    return cssClass;
  }

  get firstCellClass() {
    let cellClass = "5/12";

    if (this.currentPurchase.soonPaymentPurchaseCheck) {
      cellClass = "3/12";
    }
    if (this.hasUserMoneyFlow) {
      cellClass = "3/12";
    }

    if (this.currentPurchase.modifyPurchase || this.currentPurchase.previousReserveAmount) {
      cellClass = "2/12"
    }

    if ((this.currentPurchase.modifyPurchase || this.currentPurchase.previousReserveAmount) && this.currentPurchase.soonPaymentPurchaseCheck) {
      cellClass = "1/12"
    }

    if (this.hasUserMoneyFlow && (this.currentPurchase.modifyPurchase || this.currentPurchase.previousReserveAmount)) {
      cellClass = "1/12";
    }

    return cellClass;
  }

  get sellingProductsWithTax() {
    return this.sellingBooks || this.sellingMerchandising;
  }

  get reserveAmountValue() {
    let reserve = this.currentPurchase.reserveAmount.toString() || "0";
    if (reserve === "0") {
      reserve = undefined;
    }

    return round(reserve, 2);
  }

  get previousReserveAmountValue() {
    let reserve = this.currentPurchase.previousReserveAmount.toString() || "0";
    if (reserve === "0") {
      reserve = undefined;
    }

    return round(reserve, 2);
  }

  get reserveAmountReadOnly() {
    return this.purchaseFinished || !this.hasPurchaseLines;
  }

  get purchaseTagListSelected(): Array<Record<string, string>> {
    return (this.currentPurchase.tags || []).map((e: any) => {
      return { ...e, active: true };
    });
  }

  set purchaseTagListSelected(value) {
    this.currentPurchase.tags = value;
    if (!this.currentPurchase.soonPaymentPurchaseCheck) {
      this.currentPurchase.reserveAmountTouched = true;
      this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
      this.currentPurchase.reserveAmountTouched = false;
    } else {
      this.setSoonPayment()
    }
  }

  private isZero(amount: number) {
    return amount === 0;
  }

  private lineContainsBonus(line: PurchaseLine) {
    return (line.product as any).bonus.length > 0;
  }
  private created() {
    this.initializeComponent();
  }

  private mounted() {
    this.zipcodes = this.assets.zipCodesJson
  }

  private initializeComponent() {
    this.fetchPurchaseTags();
    this.fetchProvinceList();
    this.fetchCountryList();
  }

  private giftPurchaseLine(line: PurchaseLine) {
    const giftLine = new PurchaseLine();
    const bonuses = (line.product as any).bonus;
    if (bonuses && bonuses.length > 0) {
      const bonus = bonuses[0];
      giftLine.color = LineColor.Primary;
      giftLine.gift = true;
      giftLine.amount = bonus.totalAmountGift * line.amount;
      const level = bonus.targetProducts[0].productLevel;
      giftLine.productName = `${giftLine.amount
        } plazas regalo · Nivel ${level}`;
      giftLine.totalPrice = 0;
    }
    return giftLine;
  }
  private fetchPurchaseTags() {
    this.$store.dispatch("fetchPurchaseTagList").then(res => { }, err => { });
  }

  private reservationValueChanged(newValue: string) {
    this.currentPurchase.reserveAmountTouched = true;
    this.currentPurchase.reserveAmount = Number(newValue);
    // getCurrentPurchaseTotalPrice
    if (this.currentPurchase.modifyPurchase) {
      let product = Object.assign({}, this.currentPurchase);
      this.$store.dispatch("updateCurrentPurchase", product);
    } else {
      this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    }

    this.currentPurchase.reserveAmountTouched = false;
  }

  private checkReserveAmount() {
    if (this.currentPurchase.reserveAmount < this.calculatedReserveAmount) {
      this.currentPurchase.reserveAmountTouched = false;
      this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    }
  }

  private async fetchInternalBusinessList() {
    const payload = {
      limit: 20
    };
    this.internalBusinessList = await this.$store.dispatch(
      "fetchInternalBusiness",
      payload
    );
  }

  private paymentMethodSelected(paymentMethod: string) {
    this.currentPurchase.paymentMethod = Number(paymentMethod);
  }

  private checkMandatoryFields() {
    let result = true;
    const nif = (this.fiscalData as any).nif;
    if (!nif || nif === "") {
      this.error.fiscalData.nif = "Campo vacío";
      result = false;
    }

    const postalCode = (this.fiscalData as any).postalCode;
    if (!postalCode || postalCode === "") {
      this.error.fiscalData.postalCode = "Campo vacío";
      result = false;
    } else if (!postalCode || postalCode.trim().length < 5) {
      this.error.fiscalData.postalCode = "CP está incompleto";
      result = false;
    }

    const firstName = (this.fiscalData as any).firstName;
    if (!firstName || firstName === "" || firstName === "SIN DATOS") {
      this.error.fiscalData.firstName = "Campo obligatorio";
      result = false;
    }

    const lastName = (this.fiscalData as any).lastName;
    if (!lastName || lastName === "" || lastName === "SIN DATOS") {
      this.error.fiscalData.lastName = "Campo obligatorio";
      result = false;
    }

    const email = (this.fiscalData as any).email;
    if (!email || email === "" || email === "SIN@DATOS.COM") {
      this.error.fiscalData.email = "Campo obligatorio";
      result = false;
    }

    // if (this.currentPurchase.paymentMethod == 2 && this.currentPurchase.card_last_digits == "") {
    //   this.error.currentPurchase.card_last_digits = "Campo vacío";
    //   result = false;
    // }

    // if (this.passportDniError) {
    //   this.error.fiscalData.nif = this.passportDniError;
    // }

    return result;
  }

  get passportDniError() {
    try {
      const field = (this.fiscalData as any).nif || "";
      if (!field) {
        return;
      }
      // dni| nif
      const isDni = UtilsService.validateDni(field);
      const isNie = UtilsService.validateNie(field);
      const isPassport = /^[a-z]{3}[0-9]{6}[a-z]?$/i.test(
        (this.fiscalData as any).nif
      ); // passport

      const valid = isDni || isNie || isPassport;
      return valid ? "" : "DNI, NIE o Pasaporte no Válido";
    } catch (_) {
      return;
    }
  }

  private duplicateFiscalDataExtension() {
    this.fiscalData = {
      'user': this.acquiredCourses.userId,
      'userId': '',
      'email': this.currentPurchase.client.user.email || 'SIN@DATOS.COM',
      'address': this.currentPurchase.client.user.profile.address || 'SIN DATOS',
      'postalCode': this.currentPurchase.client.user.profile.postalCode,
      'country': this.currentPurchase.client.user.profile.country || 'SIN DATOS',
      'town': this.currentPurchase.client.user.profile.town || 'SIN DATOS',
      'state': this.currentPurchase.client.user.profile.state || 'SIN DATOS',
      'firstName': this.currentPurchase.client.user.firstName || 'SIN DATOS',
      'lastName': this.currentPurchase.client.user.lastName || 'SIN DATOS',
      'secondLastName': this.currentPurchase.client.user.secondLastName || 'SIN DATOS',
      'nif': this.currentPurchase.client.user.profile.nif,
      'phone': this.currentPurchase.client.user.profile.phone || '34',
      'id': '',
      "isDefault": true
    }
  }

  get searchAutocompletePlaceholder() {
    return "Buscar datos fiscales";
  }

  public searchCallback() {
    if (this.searchStringFiscalData === "") {
      this.selectedOptionFiscalData = null;
    }
    this.fetchClientFiscalDataExtension();
  }

  private fetchClientFiscalDataExtension() {
    const payload = {
      limit: 20,
      search: this.searchStringFiscalData
    };
    this.$store.dispatch("fetchFiscalDataExtension", payload)
      .then((res) => {
        this.searchFiscalDataExtensionsList = res.results
      });;
  }

  private selectFiscalData(option: any, modifyPurchase?: any, index?: any) {
    this.selectedOptionFiscalData = option;
    this.selectedClientFiscalData = this.searchFiscalDataExtensionsList.filter((item: any) => item.id == this.selectedOptionFiscalData.id)[0]

    if (this.selectedClientFiscalData) {
      this.fiscalData = {
        'user': this.currentPurchase.client.user.id,
        'userId': '',
        'email': this.selectedClientFiscalData.email || 'SIN@DATOS.COM',
        'address': this.selectedClientFiscalData.address || 'SIN DATOS',
        'postalCode': this.selectedClientFiscalData.postalCode,
        'country': this.selectedClientFiscalData.country || 'SIN DATOS',
        'town': this.selectedClientFiscalData.town || 'SIN DATOS',
        'state': this.selectedClientFiscalData.state || 'SIN DATOS',
        'firstName': this.selectedClientFiscalData.firstName || 'SIN DATOS',
        'lastName': this.selectedClientFiscalData.lastName || 'SIN DATOS',
        'secondLastName': this.selectedClientFiscalData.secondLastName || 'SIN DATOS',
        'nif': this.selectedClientFiscalData.nif,
        'phone': this.selectedClientFiscalData.phone || '34',
        'id': '',
        "isDefault": true
      }
    }
  }

  private rescatarFiscalDataExtension() {
    this.rescatarFiscalDataBool = true
  }

  public showAddPaymentInfo(value: Boolean) {
    if (value == true) {
      this.setCurrentBudget(new Budget());
    }
    this.showAddPaymentInfoBoolean = value;
  }

  @Watch("clientPaymentSelected")
  private watchClientPaymentSelected(newVal: any, oldVal: any) {
    if (newVal != undefined && newVal.active == false && oldVal != undefined && oldVal != "") {
      this.updateClientPayment(newVal)
    }
  }


  private updateClientPayment(newVal: any) {
    newVal.active = true
    this.$store
      .dispatch("updateClientPayment", { id: this.currentPurchase.client.user.id, viewStatus: 0, ...newVal })
      .then((res) => {
        if (res.message != '') {
          // this.showNotification(res.message);
          this.fetchClientPayment(0)
        }
      })
      .catch((err) => {
        this.showNotification(err.error, SpotlightTextColor.Error);
      });
  }

  private fetchClientPayment(viewStatus: number) {
    this.$store
      .dispatch("fetchClientPayment", { id: this.currentPurchase.client.user.id, viewStatus: viewStatus })
      .then((res) => {
        this.clientPayments = res.data.filter((item: any) => item.status != 1)
        this.clientPaymentSelected = this.clientPayments.filter((item: any) => item.active)[0]
        if (!this.clientPaymentSelected) {
          this.clientPaymentSelected = this.clientPayments[0]
        }
        if (res.info != '') {
          this.showNotification(res.info, SpotlightTextColor.Error);
        }
        this.$forceUpdate();
      });
  }

  get creditCardFormated() {
    const creditCard = Object.assign({}, this.currentBudget.creditCard);
    const splittedDate = creditCard.dateExpiration.split('/');
    const month = Number(splittedDate[0]) - 1;

    let dateDayjs = dayjs();
    let year = dateDayjs.year().toString();
    year = year.substring(0, year.length - 2);
    year += splittedDate[1];
    dateDayjs = dateDayjs
      .set('date', 1)
      .set('month', month)
      .set('year', Number(year));
    creditCard.dateExpiration = dateDayjs.toISOString();
    creditCard.relatedProduct = this.currentPurchase.purchaseLines.length > 0 && this.currentPurchase.purchaseLines[0].product && this.currentPurchase.purchaseLines[0].product.name ? this.currentPurchase.purchaseLines[0].product.name : undefined
    return creditCard;
  }

  private getPaymentInfo() {
    let info = {};
    if (this.isCardMethodSelected) {
      info = { creditCard: this.creditCardFormated };
    } else if (this.isDirectDebitMethodSelected) {
      // const bankId = this.currentBudget.bankAccount.bank.id;
      // this.currentBudget.bankAccount.bank = bankId;
      if (process.env.VUE_APP_DEBUG) {
        // this.currentBudget.bankAccount.bank = "572a9108-f910-4cb6-942c-cedb529e29e3";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      } else {
        // this.currentBudget.bankAccount.bank = "7591c2a8-691c-4862-aa57-fc374e9117a2";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      this.currentBudget.bankAccount.relatedProduct = this.currentPurchase.purchaseLines.length > 0 && this.currentPurchase.purchaseLines[0].product && this.currentPurchase.purchaseLines[0].product.name ? this.currentPurchase.purchaseLines[0].product.name : undefined
      info = { bankAccount: this.currentBudget.bankAccount };
    }
    return info;
  }

  private addPaymentInfo() {
    if (this.checkFormValidation()) {
      this.newPaymentAdded = true
      let errorNotification = null;
      let holder = null;

      if (this.isCardMethodSelected) {
        holder = this.currentBudget.creditCard.holder;
      } else if (this.isDirectDebitMethodSelected) {
        holder = this.currentBudget.bankAccount.holder;
      }

      if (holder && this.currentPurchase.client.user.fullName !== holder) {
        errorNotification = "El nombre del titular ha de ser igual al NOMBRE del cliente actual";
      }

      if (errorNotification) {
        this.showNotification(errorNotification, SpotlightTextColor.Error);
        this.newPaymentAdded = false
      } else {
        this.showAddPaymentInfo(false)
        this.$store
          .dispatch("newClientPayment", { id: this.currentPurchase.client.user.id, viewStatus: 0, ...this.getPaymentInfo() })
          .then((res) => {
            this.fetchClientPayment(0)
            this.showNotification(res.message);
            this.newPaymentAdded = false
          })
          .catch((err) => {
            this.showNotification(err.message, SpotlightTextColor.Error);
            this.newPaymentAdded = false
          });
      }
    }
  }

  private checkFormValidation() {
    if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()
    ) {
      return this.directDebitFieldsValidation();
    } else if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()
    ) {
      return this.cardFieldsValidation();
    }
  }

  private directDebitFieldsValidation() {
    if (this.currentBudget.bankAccount) {
      const error: any = { bankAccount: {}, budgetSepaInfo: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false
      // if (!(this.currentBudget.bankAccount as any).bank) {
      //   error.bankAccount['bank'] = emptyField;
      // }
      const bankNumber = (this.currentBudget.bankAccount as any).number;
      if (!bankNumber) {
        error.bankAccount['number'] = emptyField;
        errores = true
      } else if (bankNumber.trim().length < 24) {
        error.bankAccount['number'] = errorField;
        errores = true
      }
      if (!(this.currentBudget.bankAccount as any).holder) {
        error.bankAccount['holder'] = 'Dale al botón COPIAR TITULAR';
        errores = true
      }
      if (!(this.currentBudget.bankAccount as any).number) {
        error.bankAccount['number'] = emptyField;
        errores = true
      }

      if (errores) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private cardFieldsValidation() {
    if (this.currentBudget.creditCard) {
      const error: any = { creditCard: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false

      const cardNumber = (this.currentBudget.creditCard as any).number;
      if (!cardNumber) {
        error.creditCard['number'] = emptyField;
        errores = true
      } else if (cardNumber.trim().length < 16) {
        error.creditCard['number'] = errorField;
        errores = true
      }
      const dateExpiration = (this.currentBudget.creditCard as any)
        .dateExpiration;
      if (!dateExpiration) {
        error.creditCard['dateExpiration'] = emptyField;
        errores = true
      } else if (dateExpiration.trim().length < 5) {
        error.creditCard['dateExpiration'] = errorField;
        errores = true
      }
      const cvv = (this.currentBudget.creditCard as any).cvv;
      if (!cvv) {
        error.creditCard['cvv'] = emptyField;
        errores = true
      } else if (cvv.trim().length < 3) {
        error.creditCard['cvv'] = errorField;
        errores = true
      }
      if (!(this.currentBudget.creditCard as any).holder) {
        error.creditCard['holder'] = 'Dale al botón COPIAR TITULAR';
        errores = true
      }

      if (errores) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private setAcceptanceFieldError(error: any) {
    const newError = error;
    this.$store.commit('setAcceptanceFieldError', newError);
  }

  private copyHolderName() {
    if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()) {
      this.currentBudget.bankAccount.holder = this.currentPurchase.client.user.fullName
    } else if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()) {
      this.currentBudget.creditCard.holder = this.currentPurchase.client.user.fullName
    }

    this.setCurrentBudget(this.currentBudget)

    // Forzar refresco de los componentes hijos
    const choosePaymentMethodComponent = this.$refs.componentePagoAplazado as ChoosePaymentMethod
    if (choosePaymentMethodComponent.$children) {
      choosePaymentMethodComponent.$children.forEach((child: any) => {
        child.$forceUpdate()
      });
    }
  }

  private setSoonPayment() {
    if (this.currentPurchase.soonPaymentPurchaseCheck) {
      if (!this.currentPurchase.modifyPurchase) {
        this.currentPurchase.reserveAmount = this.currentPurchase.soonPaymentPurchaseCheck ? this.currentPurchase.totalPriceWithoutTax : 0
      } else if (!this.currentPurchase.reserveAmount) {
        this.currentPurchase.reserveAmount = this.currentPurchase.totalPaymentPending
      }
      if (this.currentPurchase.reserveAmount) {
        this.currentPurchase.reserveAmountTouched = true;
        this.currentPurchase.reserveAmount = this.getPurchaseLinesTotalPrice()
        this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
        this.currentPurchase.reserveAmountTouched = false;
      } else {
        this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
      }
    } else {
      this.currentPurchase.tags = undefined
      this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    }
  }

  private getPurchaseLinesTotalPrice() {
    let total = 0;
    const typeOfPrice = TypeOfPriceLiteral[this.getTypeOfPrice];
    if (this.currentPurchase.purchaseLines.length > 0) {
      total = this.currentPurchase.purchaseLines.reduce(
        (total: number, line: any) => {
          if (line.product) {
            const taxForm = line.product.tax / 100;
            if (line.repeater) {
              const tax = line.product.repeat * line.amount * taxForm;
              return total + line.product.repeat * line.amount + tax;
            } else {
              const tax = line.product[typeOfPrice] * line.amount * taxForm;
              return total + line.product[typeOfPrice] * line.amount + tax;
            }
          } else {
            return total;
          }
        },
        0
      );
    }
    return total;
  }
}
